import { Http } from "../axios/interceptors";

export const allEmployeesByCompany = async (param) =>
  Http("GET", `/Employees/GetByCompany?`, param);

export const getEmployee = async (id) =>
  Http("GET", `/Employees/Get?idEmployee=${id}`);

export const createOrEditEmployee = async (body, id = null) =>
  id
    ? Http("PUT", `/Employees/Update`, null, body)
    : Http("POST", "/Employees/Create", null, body);

export const deleteEmployee = async (guid) =>
  Http("DELETE", `/Employees/Delete?idEmployee=${guid}&active=false`);

export const getWorkSchedules = async (id) =>
  Http("GET", `/Employees/GetWorkSchedules?idWorkingHours=${id}`);

export const createWorkSchedules = async (body, id = null) =>
  Http("POST", `/Employees/CreateWorkSchedules?idEmployee=${id}`, null, body);

export const editWorkSchedules = async (body) =>
  Http("PUT", `/Employees/UpdateWorkSchedules`, null, body);

export const deleteWorkSchedules = async (idEmployee, idWorkingHours) =>
  Http(
    "DELETE",
    `/Employees/DeleteWorkSchedules?idEmployee=${idEmployee}&idWorkingHours=${idWorkingHours}`,
  );

export const getServicesByEmployee = async (id) =>
  Http("GET", `/Services/GetListByEmployee?idEmployee=${id}`);

export const allWorkCalendarEmployees = async (id) =>
  Http("GET", `/Employees/GetWorkCalendar?idWorkCalendar=${id}`);

export const getWorkCalendarByEmployee = async (param) =>
  Http("GET", `/Employees/GetWorkCalendarByEmployee?`, param);

export const getWorkCalendarByEmployeeByRange = async (param) =>
  Http("GET", `/Employees/GetWorkCalendarByEmployeeByRange?`, param);

export const createWorkCalendar = async (body, id = null) =>
  Http("POST", `/Employees/Create?idEmployee=${id}`, null, body);

export const updateWorkCalendar = async (body, id = null) =>
  Http("PUT", `/Employees/UpdateWorkCalendar`, null, body);

export const deleteWorkCalendar = async (idEmployee, idWorkCalendar) =>
  Http(
    "DELETE",
    `/Employees/DeleteWorkCalendar?idEmployee=${idEmployee}&idWorkCalendar=${idWorkCalendar}`,
  );
